module.exports = __webpack_public_path__ + "static/img/about_us_main.95dd8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/mobile/about_us_main.png
// module id = j/LA
// module chunks = 1